import { GroupResourcesPane } from '@/components/GroupPage/GroupResourcesPane';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(GroupResourcesPane, {
  requiresEvery: [RouteRestrictions.COMMUNITY_ACCESS],
});
